import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import FormInput from "../../components/common/FormInput/FormInput";

import UploadImage from "../../components/common/UploadImage/UplaodImage";

import { FaArrowLeftLong } from "react-icons/fa6";
import ServiceListing from "./ServiceListing/ServiceListing";


const Service = () => {

  return (
    <>
   <ServiceListing />
    </>
  );
};

export default Service;
